<template>
  <div v-if="frame" class="shop-tag" @mouseover="onVideoAction('pause')" @mouseout="onVideoAction('play')" @click="onClick">
    <div class="shop-tag__wrapper" :class="classes" ref="textContent" :style="wrapperStyles" >
      <div class="shop-tag__content" :style="contentStyles">
        <!-- see computed properties in mixins -->
        <span v-if="meta.title" class="shop-tag__title">{{ title }}</span>
        <span v-if="meta.text" class="shop-tag__text">{{ text }}</span>
        <span v-if="meta.eyecatcher" class="shop-tag__eyecatcher">{{ eyecatcher }}</span>
        <a v-if="linkLabel" class="shop-tag__button" href="#" :style="buttonStyles">{{ linkLabel }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { whiteColor, blackColor } from "./utils";
import { base, titleAndText, eyecatcher, linkLabel } from './mixins/multilang'
import { analytics } from './mixins/analytics/'

const boxSizes = {
  0: "bs-xs",
  1: "bs-s",
  2: "bs-m",
  3: "bs-l",
  4: "bs-xl"
};

export default {
  name: "shop",
  mixins: [base, titleAndText, eyecatcher, linkLabel, analytics],
  props: ["meta", "frame", "dimensions", "isLastFrame"],
  created() {
    // colorScheme
    this.initTag()
  },
  mounted() {},
  beforeDestroy() {},
  watch: {
    isLastFrame(isLast) {
      console.log('logicTag isLastFrame %s. current frame %v', isLast, this.frame)
      if (isLast && this.onLastFrame.action !== 'none') {
        this.$emit('action', this.onLastFrame)
      }
    },
    meta: "initTag"
  },
  data() {
    return {
      videoElement: null,
      colors: null,
      // indicates if the associated URL has been opened.
      // if so, do not start play on mouse leave
      opened: false
    };
  },
  computed: {
    wrapperStyles: function() {
           // version to kick off update from forceUpdate
      var v = this.version
      return {
        "color": this.colors[1] || blackColor // set the current color, same as background color, will be inherited from ::before arrow
      };
    },
    contentStyles: function() {
           // version to kick off update from forceUpdate
      var v = this.version
      return {
        "color": this.colors[0] || blackColor,
        "background-color": this.colors[1] || whiteColor,
        "border-color": this.colors[2] || whiteColor
      };
    },
    buttonStyles: function() {
           // version to kick off update from forceUpdate
      var v = this.version
      return {
        "color": this.colors[3] || whiteColor,
        "background-color": this.colors[4] || blackColor
      };
    },
    classes: function() {
           // version to kick off update from forceUpdate
      var v = this.version
      var bs = boxSizes[Math.floor(this.dimensions.w / 320)] || "bs-m";
      var cs = (this.meta.colorScheme || {}).key;
      var align = this.meta.alignement || 'h-left'
      var tAlign = this.meta.textAlignement || 't-center'
      console.log("classes", [bs, cs, align, tAlign]);
      return [bs, cs, align, tAlign];
    }
  },
  methods: {
    initTag() {
      var cs = this.meta.colorScheme
      this.colors = cs.colors || {}
      this.onLastFrame = this.meta.onLastFrame
    },
    onClick(ev) {
      console.log("onClick", ev);
      ev.preventDefault();
      // suppress mouse out -> play toggle behavoiur
      this.opened = true;
      this.$emit("action", this.meta.behaviour);
      this.trackTag("Bubble")
      /*
      if (!this.meta.URL) {
        return
      }
      ev.preventDefault();
      this.opened = true;
      this.$emit("action", {
        action: "open",
        target: "_blank",
        value: this.meta.URL
      });
      */
    },
    onVideoAction(action) {
      // if the url has been opened, then skip the leave for once
      console.log("onVideoAction", action)
      if (!this.opened) {
        this.$emit("videoaction", {
          action: action
        });
      } else {
        // reset it for the next round
         this.opened = false
      }
    },
    /* called by the preview tag in order to update the visual representation in this context */
     forceUpdate(meta) {
      console.log("forceUpdate", this.version)
      // init meta based props
      this.initTag()
      // inc version that will kick of computed
      this.version = this.version + 1
      this.selectedLanguage = this.meta.text.lang
    }
  }
};
</script>
